import focusLock from 'dom-focus-lock'

const TAB = 9
const ESC = 27
const UP = 38
const DOWN = 40

export default function ($toggle, { timeout = 0 }) {
  let $menuContainer = $toggle.nextElementSibling
  let $menu = $menuContainer.querySelector('[role="menu"]')
  let $options = $menu.querySelectorAll('[role="menuitem"]')
  let selectedIndex = 0

  $toggle.addEventListener('click', toggle)
  $toggle.addEventListener('keydown', onToggleKeyDown)
  $menu.addEventListener('keydown', onKeyDown)
  $menu.addEventListener('mouseover', selectOption)

  function toggle () {
    if ($menuContainer.hidden) {
      show()
    } else {
      hide()
    }
  }

  function show () {
    $toggle.setAttribute('aria-expanded', 'true')
    $menuContainer.hidden = false
    if (timeout) {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          $menuContainer.classList.add('is-visible')
        })
      })
    }
    focusLock.on($menu)
    selectedIndex = 0
    $options[0].focus()

    window.setTimeout(() => {
      window.addEventListener('focus', hideOnFocusOut, true)
      window.addEventListener('click', hideOnFocusOut)
    }, 0)
  }

  function hide () {
    $toggle.setAttribute('aria-expanded', 'false')
    $menuContainer.classList.remove('is-visible')
    if (timeout) {
      window.setTimeout(() => {
        $menuContainer.hidden = true
      }, 300)
    } else {
      $menuContainer.hidden = true
    }

    window.removeEventListener('focus', hideOnFocusOut, true)
    window.removeEventListener('click', hideOnFocusOut)
  }

  function onToggleKeyDown (e) {
    if (e.which === DOWN) {
      e.preventDefault()
      show()
    }
  }

  function onKeyDown (e) {
    switch (e.which) {
      case TAB:
        e.preventDefault()
        break
      case DOWN:
        e.preventDefault()
        if (selectedIndex !== $options.length - 1) {
          selectedIndex++
        }
        $options[selectedIndex].focus()
        break
      case UP:
        e.preventDefault()
        if (selectedIndex !== 0) {
          selectedIndex--
        }
        $options[selectedIndex].focus()
        break
      case ESC:
        e.preventDefault()
        hide()
        $toggle.focus()
        break
    }
  }

  function hideOnFocusOut (e) {
    if (!isDescendant($menuContainer, e.target)) {
      hide()
    }
  }

  function selectOption (e) {
    let $option = e.target.closest('[role="menuitem"]')
    if ($option) {
      $option.focus()
    }
  }

  return () => {
    $toggle.removeEventListener('click', toggle)
    $toggle.removeEventListener('keydown', onToggleKeyDown)
    $menu.removeEventListener('keydown', onKeyDown)
    window.removeEventListener('focus', hideOnFocusOut, true)
    window.removeEventListener('click', hideOnFocusOut)
    $menu.removeEventListener('mouseover', selectOption)
  }
}

function isDescendant (parent, child) {
  let node = child.parentNode
  while (node !== null) {
    if (node === parent) {
      return true
    }
    node = node.parentNode
  }
  return false
}



// WEBPACK FOOTER //
// ./src/js/components/menu.js